	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class EmploymentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Employment');
	}
	
	loadAll(id: System.Guid): Observable<ePM.Logic.Employment[]> {
		return this.myBaseService.loadAll(this.url + '/' + (id || ''));
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.Employment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Employment> {
		return this.myBaseService.getEdit(id, this.url);
	}
}
